import api from '@/apis/di/taskAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('task', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_task',
    field: {
      key: 'task_id',
      code: 'task_code',
      name: 'task_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
